module.exports = __webpack_public_path__ + "static/media/supermarket-solution.b4a1cecb.png";